import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types';
import { ProductGrid } from '../products/ProductGrid';
interface FeaturedProductsProps {
  title: string;
  subtitle?: string;
  products: Product[];
  viewAllLink?: string;
}
export function FeaturedProducts({
  title,
  subtitle,
  products,
  viewAllLink
}: FeaturedProductsProps) {
  return <section className="py-12" aria-labelledby={`${title.toLowerCase().replace(/\s+/g, '-')}-heading`} data-id="element-161" data-mp="2it7tbe791dbs">
      <div className="max-w-7xl mx-auto px-4" data-id="element-162" data-mp="2dudbaeh3vssq">
        <div className="flex items-end justify-between mb-8" data-id="element-163" data-mp="2sk2oj82h3n9d">
          <div data-id="element-164" data-mp="2sjj3vjlfukrn">
            <h2 id={`${title.toLowerCase().replace(/\s+/g, '-')}-heading`} className="text-2xl md:text-3xl font-bold text-gray-900 mb-1" data-id="element-165" data-mp="2sm5bfj8bx09v">
              {title}
            </h2>
            {subtitle && <p className="text-gray-600" data-id="element-166" data-mp="31l0jl0uxokft">{subtitle}</p>}
          </div>
          {viewAllLink && <Link to={viewAllLink} className="hidden sm:flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium transition-colors" data-id="element-167" data-mp="2wn8v6gthzggd">
              View All
              <ArrowRightIcon className="w-4 h-4" data-id="element-168" data-mp="2e7meu0nuokhx" />
            </Link>}
        </div>

        <ProductGrid products={products} columns={4} data-id="element-169" data-mp="2j54oxudlt5ri" />

        {viewAllLink && <div className="mt-6 text-center sm:hidden" data-id="element-170" data-mp="2j80kjc1zbics">
            <Link to={viewAllLink} className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium transition-colors" data-id="element-171" data-mp="2o5imgihkwxba">
              View All Products
              <ArrowRightIcon className="w-4 h-4" data-id="element-172" data-mp="2x4nohyscn8s7" />
            </Link>
          </div>}
      </div>
    </section>;
}